import type { BrandInfo } from './types';

export const brandInfo: BrandInfo = {
  name: '开元体育',
  founded: '2015年',
  location: '中国·北京',
  teamSize: '500+人',
  description: '开元体育成立于2015年，是国内领先的专业体育运动平台。我们致力于为运动爱好者提供高质量的体育赛事资讯、运动健身指导及体育娱乐服务，打造一站式运动生态体验。',
  mission: '让每个人都能享受运动带来的健康与快乐，推动全民健身事业蓬勃发展。',
  vision: '成为全球最具影响力的体育运动平台，连接亿万运动爱好者，构建积极健康的运动生活方式。',
  milestones: [
    {
      year: '2015年',
      title: '平台创立',
      description: '开元体育在北京正式成立，以体育资讯为核心业务起步。',
    },
    {
      year: '2016年',
      title: '用户突破百万',
      description: '凭借高质量的内容和良好的用户体验，注册用户数突破100万。',
    },
    {
      year: '2017年',
      title: '内容体系升级',
      description: '引入运动健身指导板块，组建专业教练团队，提供科学训练方案。',
    },
    {
      year: '2019年',
      title: '用户突破千万',
      description: '注册用户突破1000万，成为国内体育类平台的领先品牌。',
    },
    {
      year: '2021年',
      title: '国际化拓展',
      description: '启动国际化战略，与多个国际体育组织建立合作关系。',
    },
    {
      year: '2023年',
      title: 'AI智能推荐',
      description: '上线AI智能内容推荐系统，为用户提供个性化的运动资讯体验。',
    },
    {
      year: '2024年',
      title: '生态全面升级',
      description: '打造运动生态闭环，整合赛事、健身、娱乐、社交等多元服务。',
    },
  ],
  honors: [
    {
      year: '2018年',
      title: '最佳体育内容平台奖',
      description: '凭借优质的内容创作和用户体验，荣获中国体育产业年度最佳内容平台奖。',
    },
    {
      year: '2019年',
      title: '互联网+体育创新奖',
      description: '在互联网技术与体育产业融合方面的创新实践获得行业认可。',
    },
    {
      year: '2020年',
      title: '用户最喜爱的体育App',
      description: '在年度用户满意度调查中名列前茅，获得广泛用户好评。',
    },
    {
      year: '2021年',
      title: '全民健身推广先进单位',
      description: '为推动全民健身事业发展做出突出贡献，获国家体育总局表彰。',
    },
    {
      year: '2022年',
      title: '最具影响力体育品牌',
      description: '品牌影响力和行业地位获得权威机构认证。',
    },
    {
      year: '2023年',
      title: '体育科技创新奖',
      description: '在AI赋能体育内容领域的技术创新获得行业高度评价。',
    },
  ],
};